import React, { Component } from 'react'
import { FontAwesomeIcon } from '../../../../CommonComponents/AssetsHelper'

export default class ErrorAlert extends Component {
  render() {
    return (
        <div className="justify-content-md-center">
        <div className="alert alert-custom alert-outline-danger fade show mb-5 col-md-12" role="alert">
            <div className="d-flex m-auto">
                <div className="alert-icon ms-2">
                    <FontAwesomeIcon type={'regular'} icon={'circle-info'} iconClass={'fs-6 text-danger'} />
                </div>
                <div className="alert-text text-left">
                    Some of your social media accounts seem disconnected from Socialwalls. Reconnect to get new posts in your widget
                </div>
            </div>
            <div className="alert-close">
                <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
            </div>
        </div>
    </div>
    )
  }
}
